import {
    Button,
    Modal,
    ModalBody,
    ModalCloseButton,
    ModalContent,
    ModalFooter,
    ModalHeader,
    ModalOverlay,
    Text,
} from '@chakra-ui/react';
import { useTranslation } from 'helpers/languages/translations';
import { intentionalyFloatingPromiseReturn } from 'utils/wrappers';
import { TGlobalCategoriesHooks } from '../../useGlobalCategories';

interface IProps {
    isDeleteOpen: TGlobalCategoriesHooks['isDeleteOpen'];
    handleCloseDelete: TGlobalCategoriesHooks['handleCloseDelete'];
    isDeleteLoading: TGlobalCategoriesHooks['isDeleteLoading'];
    handleDeleteGlobalCategory: TGlobalCategoriesHooks['handleDeleteGlobalCategory'];
    isDeleteMultiple: TGlobalCategoriesHooks['isDeleteMultiple'];
    deleteInitialRef: TGlobalCategoriesHooks['deleteInitialRef'];
}

const DeleteGlobalCategoryModal = ({
    isDeleteOpen,
    handleCloseDelete,
    isDeleteLoading,
    handleDeleteGlobalCategory,
    isDeleteMultiple,
    deleteInitialRef,
}: IProps) => {
    const translate = useTranslation();
    return (
        <Modal isCentered initialFocusRef={deleteInitialRef} isOpen={isDeleteOpen} onClose={handleCloseDelete}>
            <ModalOverlay />
            <ModalContent>
                <ModalHeader tabIndex={-1} ref={deleteInitialRef}>
                    <Text as="h3">
                        {translate(
                            isDeleteMultiple
                                ? 'global_categories.modal.titleDeleteMultiple'
                                : 'global_categories.modal.titleDeleteSingle',
                        )}
                    </Text>
                </ModalHeader>
                <ModalCloseButton mt="2" isDisabled={isDeleteLoading} />
                <ModalBody fontSize="sm">
                    <Text>{translate('global_categories.modal.deleteInfo')}</Text>
                </ModalBody>
                <ModalFooter>
                    <Button isDisabled={isDeleteLoading} variant="outline" size="sm" mr={3} onClick={handleCloseDelete}>
                        {translate('global_categories.modal.cancel')}
                    </Button>
                    <Button
                        onClick={intentionalyFloatingPromiseReturn(handleDeleteGlobalCategory)}
                        isLoading={isDeleteLoading}
                        colorScheme="red"
                        size="sm"
                    >
                        {translate('global_categories.modal.deleteAction')}
                    </Button>
                </ModalFooter>
            </ModalContent>
        </Modal>
    );
};

export default DeleteGlobalCategoryModal;
